import { Accordion, Typography } from '@sravni/react-design-system';

import { useAppSelector } from 'shared/lib';
import { AdaptiveCard } from 'shared/ui/AdaptiveCard';

import { checkIsFormFullFilledSelector } from 'entities/creditForm';
import { wlBlockFFSelector } from 'entities/whiteLabels';

import { useSummarySendContact } from 'widgets/AnketaWidget/lib';
import { useValidateData } from 'widgets/AnketaWidget/lib/useValidateData';

import { CommonSummary, type ICommonSummaryProps } from '../CommonSummary/CommonSummary';

import styles from './UserDataSummary.module.scss';
import { UserDataSummaryTexts } from './UserDataSummary.texts';
import { UserDataSummarySkeleton } from './UserDataSummarySkeleton';

interface IUserDataSummary extends ICommonSummaryProps {
  isLoading?: boolean;
  toggleIsOpened?: (val: boolean) => void;
  customTitle?: string;
  customSubtitle?: string;
  isHideAccordionData?: boolean;
  onAutoValidationError?: () => void;
  onAutoValidationSuccess?: () => void;
}

export const UserDataSummaryAccordion: FC<IUserDataSummary> = ({
  isLoading = false,
  toggleIsOpened,
  customTitle,
  customSubtitle,
  onFormSubmit,
  isHideAccordionData,
  onAutoValidationError,
  onAutoValidationSuccess,
  ...props
}) => {
  const { isHideSummary } = useAppSelector(wlBlockFFSelector) || {};
  const isFormReady = useAppSelector(checkIsFormFullFilledSelector);

  useSummarySendContact();

  const { isValidating } = useValidateData({
    onSuccess: onAutoValidationSuccess,
    onError: onAutoValidationError,
  });

  if (isLoading || isValidating) {
    return <UserDataSummarySkeleton />;
  }

  return (
    <AdaptiveCard
      className={styles.accordion}
      color="light"
    >
      <Accordion
        defaultIndex={isHideSummary ? undefined : [0]}
        padding={false}
        onChange={(openAccordionItems: number[]) => {
          toggleIsOpened?.(openAccordionItems.length > 0);
        }}
      >
        <Accordion.Item
          title={
            <Typography.Text
              strong
              size={16}
            >
              {customTitle || UserDataSummaryTexts.caption}
            </Typography.Text>
          }
          subtitle={!isFormReady ? undefined : customSubtitle}
          unmountOnExit={false}
        >
          <CommonSummary
            onFormSubmit={onFormSubmit}
            isHideAccordionData={isHideAccordionData}
            {...props}
          />
        </Accordion.Item>
      </Accordion>
    </AdaptiveCard>
  );
};
